import React from 'react';

import { WrappedFieldProps } from 'redux-form';

import CardFollowupTemplate, { CardFollowupTemplateProps } from './CardFollowupTemplate';

export interface FieldComponentCardFollowupTemplateProps extends WrappedFieldProps {
  squigglies?: CardFollowupTemplateProps['squigglies'];
  textEditorVariant?: CardFollowupTemplateProps['textEditorVariant'];
}

const FieldComponentCardFollowupTemplate: React.FC<FieldComponentCardFollowupTemplateProps> = ({
  squigglies,
  textEditorVariant,
  input: { value, onChange, onBlur },
  meta: { error, invalid, touched },
  meta,
  ...rest
}) => (
  <CardFollowupTemplate
    squigglies={squigglies}
    textEditorVariant={textEditorVariant}
    value={value}
    onChange={onChange}
    error={error}
    invalid={invalid}
    touched={touched}
    onBlur={onBlur}
    {...rest}
  />
);

export default FieldComponentCardFollowupTemplate;
